import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseComponent } from '../../shared/base.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-external-link-dialog',
    templateUrl: './external-link-dialog.component.html',
    styleUrls: ['./external-link-dialog.component.scss'],
    standalone: false
})
export class EternalLinkDialogComponent
  extends BaseComponent
  implements OnInit
{
  isSpinnerLoading: boolean = true;
  externalUrl!: SafeResourceUrl;
  locale: string = 'en-US';

  constructor(
    private dialogRef: MatDialogRef<EternalLinkDialogComponent>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) private dialogData: any
  ) {
    super();
  }

  ngOnInit() {
    if (this.dialogData && this.dialogData.params) {
      this.externalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.dialogData.params.url
      );
      this.locale = this.dialogData.params.locale;
    }
    this.dialogRef.addPanelClass('custom-dialog-without-close');

    setTimeout(() => {
      this.isSpinnerLoading = false;
    }, 5000);
  }

  closeModal() {
    setTimeout(() => {
      this.dialogRef.close();
    }, 150);
  }

  closeCancelModal() {
    this.dialogRef.close();
  }
}
